import React from "react";
import { NavLink } from "react-router";
import RoleAwareComponent from "../auth/RoleAwareComponent";

export default class NavLinkWithRole extends RoleAwareComponent {
  render() {
    const { authorize, action, showText, ...linkProps } = this.props;

    const jsx = <NavLink {...linkProps} />;

    return this.shouldBeVisible() ? jsx : showText ? <span>{linkProps.children}</span> : null;
  }
}
